import clsx from "clsx";
import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  button: {
    width: "100%",
    "background-color": props => props.color,
    color: "white",
    "margin-top": 15,
    padding: [5, 10],
    border: "none",
    "font-size": 14,
    "border-radius": 3,
    cursor: "pointer",
  },
});

const Submit = ({ color, disabled, className, ...props }) => {
  const classes = useStyles({ color: disabled ? "#ccc" : color ?? "#f90" });
  return (
    <input
      type="submit"
      disabled={disabled}
      className={clsx(classes.button, className)}
      {...props}
    />
  );
};

export default Submit;
